import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">
        <path d="M2782 8170 c-40 -11 -97 -32 -125 -47 -77 -41 -187 -155 -225 -233
-36 -73 -68 -205 -59 -241 l6 -24 2061 3 2060 2 0 140 c0 115 -4 151 -20 197
-28 80 -83 141 -165 183 l-68 35 -1696 2 c-1645 2 -1698 1 -1769 -17z"/>
<path d="M3192 5798 l3 -603 106 -3 c83 -2 110 1 122 12 12 12 14 72 13 380
-1 201 1 366 4 366 4 0 203 -290 255 -373 64 -102 139 -212 146 -215 5 -2 9
-8 9 -14 0 -16 90 -138 110 -148 20 -11 179 -14 204 -4 14 6 16 66 16 583 0
317 -3 586 -6 599 -6 22 -9 23 -126 20 l-120 -3 0 -355 c1 -195 -3 -364 -7
-375 -7 -18 -12 -13 -42 35 -31 52 -51 81 -164 246 -25 36 -45 68 -45 71 0 3
-22 35 -49 72 -26 36 -54 77 -61 91 -7 14 -44 69 -82 123 l-69 97 -110 0 -109
0 2 -602z"/>
<path d="M4387 6393 c-4 -3 -7 -273 -7 -599 0 -530 2 -592 16 -598 30 -11 209
-7 222 6 8 8 12 63 12 184 l0 171 133 6 c247 10 372 75 453 235 27 54 29 64
29 182 0 116 -2 129 -28 181 -57 118 -142 187 -269 220 -61 16 -109 19 -313
19 -133 0 -245 -3 -248 -7z m516 -247 c42 -20 57 -34 75 -71 48 -100 17 -209
-73 -254 -40 -20 -63 -23 -158 -25 l-112 -1 -3 180 c-1 98 0 186 3 194 4 11
25 13 110 8 86 -4 115 -10 158 -31z"/>
<path d="M6525 6394 c-112 -29 -217 -83 -299 -154 -96 -84 -173 -250 -183
-395 -6 -87 7 -206 26 -243 5 -10 24 -48 42 -87 23 -50 52 -90 103 -141 83
-82 132 -113 241 -150 79 -27 84 -28 380 -32 165 -2 468 -1 673 3 l372 7 0
597 0 596 -668 2 c-367 1 -676 0 -687 -3z m31 -429 c106 -31 154 -147 104
-249 -74 -152 -307 -108 -327 62 -4 40 -1 60 16 95 26 54 48 75 98 93 48 17
50 17 109 -1z"/>
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
